<template>
    <div style="display:flex;padding-bottom: 10px;">
        <div style="flex:1">
            <slot name="header"></slot>
        </div>
        <div>
            <slot name="actions"></slot>
        </div>
    </div>
</template>